// firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDg4N5X0GLo9ibbq1MNIh1GMgHNZb7-pjY",
  authDomain: "safemouv-vtc.firebaseapp.com",
  projectId: "safemouv-vtc",
  storageBucket: "safemouv-vtc.firebasestorage.app",
  messagingSenderId: "1096417018857",
  appId: "1:1096417018857:web:96adffff76ecea3430c178",
  measurementId: "G-WGLN2HTV3F"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
